import { BaseResponse } from './internal/baseresponse';
export class LogoutResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/logoutresult.ts